<template>
  <scale-transition>
    <div
      v-if="data.show"
      class="map-context-menu smooth-shadow"
      :style="{ top: `${data.y + 10}px`, left: `${data.x - 10}px` }"
    >
      <ul class="menu">
        <li @click="copyCoordinates">
          <icon size="18">location_on</icon>Copy Coordinates
        </li>
        <li v-if="getCommentMode === 'EDIT'" @click="showAddComments">
          <icon size="18">comment</icon>Add Comment
        </li>
      </ul>
      <!-- <h4>
        <icon></icon>
        {{ clickCoordinate }}
      </h4>
      <div class="button-area">
        <button @click="copyCoordinates">
          <icon size="18">file_copy</icon>Copy to ClipBoard
        </button>
      </div> -->
    </div>
  </scale-transition>
</template>

<script>
import { ScaleTransition } from "vue2-transitions";
import { mapGetters } from "vuex";

export default {
  props: {
    data: Object,
  },
  components: {
    ScaleTransition,
  },
  computed: {
    ...mapGetters("Comments", ["getCommentMode"]),
    clickCoordinate() {
      if (this.data && this.data.data && this.data.data.coordinate) {
        return [
          this.data.data.coordinate[1],
          this.data.data.coordinate[0],
        ].join(", ");
      } else {
        return "unkown coordinate";
      }
    },
  },
  methods: {
    copyCoordinates() {
      this.$clipboard(this.clickCoordinate);
      this.$notify({
        group: "main",
        title: "Copied to clipboard",
        type: "success",
      });
      this.$emit("close");
    },
    showAddComments() {
      this.$emit("addComment", {
        mode: "EDIT",
        geometry: {
          type: "Point",
          coordinates: [
            this.data.data.coordinate[1],
            this.data.data.coordinate[0],
          ],
        },
        screenLocation: {
          x: this.data.x,
          y: this.data.y,
        },
      });
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.map-context-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: var(--color-secondary);
  border-radius: 5px;
  border: 1px solid var(--border-color);
  z-index: 9999;

  .menu {
    display: flex;
    flex-direction: column;
    list-style-type: none;
    margin: 0;
    padding: 0;
    min-width: 200px;

    li {
      padding: 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
      transition: 0.3s all ease-out;

      i {
        margin-right: 10px;
      }
      &:hover {
        cursor: pointer;
        background-color: var(--color-secondary-light);
        // color: var(--color-primary);
      }
    }
  }

  &:after {
    position: absolute;
    content: "";
    top: -20px;
    left: 0px;
    right: 0;
    width: 10px;
    height: 10px;
    background-color: var(--color-primary);
    border-radius: 50px;
    border: 2px solid var(--color-primary-light);
  }
}
</style>
